import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// slices
import app from './slices/app';
import availabilities from './slices/availabilities';
import candidate from './slices/candidate';
import clients from './slices/clients';
import clockings from './slices/clockings';
import comments from './slices/comments';
import companies from './slices/companies';
import contacts from './slices/contacts';
import dashboard from './slices/dashboard';
import demands from './slices/demands';
import clockingAnomalies from './slices/clockingAnomalies';
import files from './slices/files';
import invoices from './slices/invoices';
import links from './slices/links';
import mail from './slices/mail';
import missions from './slices/missions';
import news from './slices/news';
import nfcCards from './slices/nfcCards';
import notifications from './slices/notifications';
import orders from './slices/orders';
import partners from './slices/partners';
import preferences from './slices/preferences';
import prints from './slices/prints';
import profiles from './slices/profiles';
import quotes from './slices/quotes';
import resources from './slices/resources';
import schedules from './slices/schedules';
import services from './slices/services';
import shifts from './slices/shifts';
import sites from './slices/sites';
import unavailabilities from './slices/unavailabilities';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

// const productPersistConfig = {
//   key: 'product',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: ['sortBy', 'checkout']
// };

const appReducer = combineReducers({
  app,
  availabilities,
  invoices,
  candidate,
  clients,
  clockings,
  comments,
  companies,
  contacts,
  dashboard,
  demands,
  clockingAnomalies,
  files,
  links,
  mail,
  missions,
  news,
  nfcCards,
  notifications,
  partners,
  preferences,
  prints,
  profiles,
  orders,
  quotes,
  resources,
  schedules,
  services,
  shifts,
  sites,
  unavailabilities
  // product: persistReducer(productPersistConfig, productReducer)
});

const rootReducer = (state, action) => {
  if (action.type === 'app/onLogout') {
    state = undefined;
  }

  return appReducer(state, action);
};

export { rootPersistConfig, rootReducer };
